import { Box, styled } from '@mui/material';
import { TREND_CARD_SIZES } from '../constants';
import { StatisticSize } from '../types';

const baseValueStyles = (size: StatisticSize, paperColor: string) => {
  const sizeConfig = TREND_CARD_SIZES[size] ?? TREND_CARD_SIZES.md;

  return {
    fontSize: sizeConfig.valueFontSize,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    lineHeight: 1,
    textShadow: `0 0 4px ${paperColor}, 0 0 10px ${paperColor}, 0 0 16px ${paperColor}`,
  };
};

export const TrendLabelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = TREND_CARD_SIZES[size] ?? TREND_CARD_SIZES.md;

  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: sizeConfig.labelFontSize,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    lineHeight: 1.5,
    textShadow: `0 0 4px ${theme.palette.background.paper}, 0 0 10px ${theme.palette.background.paper}, 0 0 16px ${theme.palette.background.paper}`,
  };
});

export const TrendValueWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => ({
  ...baseValueStyles(size, theme.palette.background.paper),
}));

export const TrendEmptyValueWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => ({
  ...baseValueStyles(size, theme.palette.background.paper),
  color: theme.palette.text.disabled,
}));

export const TrendErrorValueWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => ({
  ...baseValueStyles(size, theme.palette.background.paper),
  color: theme.palette.error.main,
}));

export const TrendChartWrapper = styled(Box)({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  maskImage: 'linear-gradient(to right, transparent 0%, black 30%)',
  WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 30%)',
});
